import { useState } from 'react';
import { DillModal, DillButton, DillDropdown } from '../../../general/Dill';

interface EnrollCustomersModalProps {
  open: boolean;
  onClose: () => void;
  buyerOptions: { label: string; value: string }[];
  unavailableCount: number;
  isSubmitting: boolean;
  errorMessage?: string | null;
  onSubmit: (buyerIds: string[]) => void;
  title?: string;
  subtitle?: string;
  submitLabel?: string;
}

export const EnrollCustomersModal = ({
  open,
  onClose,
  buyerOptions,
  unavailableCount,
  isSubmitting,
  errorMessage,
  onSubmit,
  title = 'Enroll customers',
  subtitle = 'Picked customers are enrolled immediately and start running this sequence right away.',
  submitLabel = 'Enroll',
}: EnrollCustomersModalProps) => {
  const [selectedBuyerIds, setSelectedBuyerIds] = useState<string[]>([]);

  const handleClose = () => {
    setSelectedBuyerIds([]);
    onClose();
  };

  return (
    <DillModal
      open={open}
      onClose={handleClose}
      title={title}
      subtitle={subtitle}
      maxWidth="420px"
      footer={
        <>
          <DillButton label="Cancel" variant="secondary" onClick={handleClose} />
          <DillButton
            label={submitLabel}
            onClick={() => onSubmit(selectedBuyerIds)}
            isDisabled={selectedBuyerIds.length === 0}
            isLoading={isSubmitting}
          />
        </>
      }>
      {errorMessage && (
        <p className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2 m-0">
          {errorMessage}
        </p>
      )}

      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-600">Customers</label>
        <DillDropdown
          items={buyerOptions}
          value={null}
          isMulti
          showSelectedItems
          multiValue={selectedBuyerIds}
          onMultiSelectChange={(newValue) => setSelectedBuyerIds(newValue.map((v) => v.value))}
          placeholder="Search customers…"
          containerClassName="h-[36px]"
          showMinimalDesign
          numberOfItemsToShow={3}
        />
        {unavailableCount > 0 && (
          <p className="text-[11px] text-gray-400 mt-1 mb-0">
            Not shown - already on a trigger's target list or enrolled in another sequence
          </p>
        )}
      </div>
    </DillModal>
  );
};

export default EnrollCustomersModal;
